import { Box, Button, Checkbox, Image, Link, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { Close } from '../Icons/Close';
import { GameRewardProps } from '../interfaces/components';
import { useTranslation } from 'react-i18next';
import TBC from '../assets/images/tbc_reward_btn.png';
import AvailableSoon from '../assets/images/available_soon.png';
import axios from 'axios';
import { getOpSys } from '../utils/helper';
import FileDownload from 'js-file-download';
import RegionToCountryName from '../utils/regions-to-countries.json';
import { disptchCTAClickObject } from '../Analytics';

const LaRocakey = 'LaRocaStamps';
const laValleeKey = 'LaValleStamps';
const bicesterKey = 'BicesterStamps';
const fidenzaKey = 'FidenzaStamps';
const sessionKey = 'bicestersid';

const GameReward = ({ villageName, active, setActive }: GameRewardProps) => {
  const { t, i18n } = useTranslation();
  const [selectedRegion, setSelectedRegion] = useState<string>('');
  const [tncAccepted, setTncAccepted] = useState<boolean>(false);
  const [btnActive, setBtnActive] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (tncAccepted && selectedRegion && selectedRegion !== '') {
      setBtnActive(true);
    } else {
      setBtnActive(false);
    }
  }, [selectedRegion, tncAccepted]);

  const onDownloadVoucher = async () => {
    setLoading(true);
    // let countryName = 'China';

    // const req = await axios.get('https://ipapi.co/json/');
    // if (req.status === 200) {
    //   countryName = req.data?.country_name;
    // }
    // console.log('Country Name', countryName);
    const device = getOpSys();

    const requestBody = {
      current_location: 'Europe',
      destination_region: selectedRegion,
      device_type: device,
      language: i18n.language,
      experience_name: 'bicester-exp',
      org_name: 'bicester',
      session_id: localStorage.getItem(sessionKey),
    };

    if (Intl) {
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      // console.log('User Country', (RegionToCountryName as any)[userTimeZone]);
      if (userTimeZone && userTimeZone !== null) {
        requestBody.current_location = (RegionToCountryName as any)[userTimeZone];
      }
    }

    const downloadVoucher = await axios.post(
      'https://yclpfhfqe8.execute-api.us-east-1.amazonaws.com/development/api/voucher/request',
      requestBody,
      { responseType: 'blob' },
    );
    if (downloadVoucher.status === 200) {
      FileDownload(downloadVoucher.data, 'voucher.pdf');

      localStorage.removeItem(LaRocakey);
      localStorage.removeItem(laValleeKey);
      localStorage.removeItem(bicesterKey);
      localStorage.removeItem(fidenzaKey);
      setLoading(false);
      disptchCTAClickObject(villageName, 'Button', 'voucher', 'download', '');
      setActive();
    } else {
      setLoading(false);
    }
  };

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex={4}
        onClick={() => setActive()}
      />
      <Box
        zIndex={7}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        bg="rgba(255, 255, 255, 1);"
        padding="15px"
        borderRadius="0px"
        width={['85vw', '250px', '700px']}
        height={['max-content', '300px', '420px']}
        display="flex"
        flexDir="column"
        justifyContent="center"
        alignItems="center"
      >
        <Close
          boxSize={[6, 6, 7]}
          position="absolute"
          top={['25px', '25px', '25px']}
          right={['25px', '25px', '25px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        <Text
          textAlign="center"
          fontWeight="400"
          fontFamily="SangBleuBPLight"
          fontSize={['16px', '16px', '18px', '20px', '20px']}
          lineHeight={['20px', '20px', '22px', '24px', '24px']}
          maxW="95%"
          mx="auto"
          whiteSpace="pre-line"
        >
          {t('minigame-reward-heading')}
        </Text>
        <Box display="flex" flexDir="column" maxW="80%" mt="10" justifyContent="center" alignItems="center">
          <Text
            textAlign="center"
            fontWeight="400"
            fontSize={['16px', '16px', '18px', '20px', '20px']}
            className="copy"
            fontFamily="JosefinSans"
          >
            {t('minigame-reward-question')}
          </Text>

          <Box display="flex" gap="5" mt="4">
            <Box
              h="46px"
              w="200px"
              // onClick={() => setSelectedRegion('China')}
              border={selectedRegion === 'China' ? '1px solid #C29F6B' : '1px solid #455255'}
              color={selectedRegion === 'China' ? 'white' : '#455255'}
              bg={selectedRegion === 'China' ? '#C29F6B' : 'white'}
              display="flex"
              alignItems="center"
              justifyContent="center"
              // cursor="pointer"
              // _hover={{ color: 'white', bg: '#C29F6B', border: '1px solid #C29F6B' }}
              opacity={0.5}
              cursor="not-allowed"
              userSelect="none"
            >
              <Image src={AvailableSoon} w="74px" h="20px" objectFit="contain" alt="the-bicester-collection" />
              <Text
                fontWeight="500"
                fontSize={['12px', '12px', '12px', '14px', '14px']}
                fontFamily="JosefinSans"
                casing="uppercase"
              >
                {t('minigame-reward-region-china')}
              </Text>
            </Box>
            <Box
              h="46px"
              w="200px"
              onClick={() => setSelectedRegion('Europe')}
              border={selectedRegion === 'Europe' ? '1px solid #C29F6B' : '1px solid #455255'}
              color={selectedRegion === 'Europe' ? 'white' : '#455255'}
              bg={selectedRegion === 'Europe' ? '#C29F6B' : 'white'}
              display="flex"
              alignItems="center"
              justifyContent="center"
              cursor="pointer"
              _hover={{ color: 'white', bg: '#C29F6B', border: '1px solid #C29F6B' }}
            >
              <Image src={TBC} w="74px" h="20px" objectFit="contain" alt="the-bicester-collection" />
              <Text
                fontWeight="500"
                fontSize={['12px', '12px', '12px', '14px', '14px']}
                fontFamily="JosefinSans"
                casing="uppercase"
              >
                {t('minigame-reward-region-europe')}
              </Text>
            </Box>
          </Box>

          {selectedRegion && (
            <Checkbox mt="7" isRequired onChange={(e) => setTncAccepted(e.target.checked)}>
              <Text
                textAlign="center"
                fontWeight="300"
                fontSize={['11px', '11px', '12px', '12px', '12px']}
                fontFamily="JosefinSans"
              >
                I have read and agree to Bicester Collection {selectedRegion}{' '}
                <Link
                  target="_blank"
                  href="https://emperia-static.s3.eu-west-2.amazonaws.com/client/bicester/hfs_voucher_terms.pdf"
                  style={{ textDecoration: 'underline' }}
                >
                  Terms & Condition
                </Link>
              </Text>
            </Checkbox>
          )}
        </Box>

        <Button
          borderRadius="0px"
          h={['40px', '50px', '50px']}
          bg="white"
          border="1px solid gray"
          onClick={onDownloadVoucher}
          color="#455255"
          _hover={{ bg: '#C29F6B', color: 'white', border: '1px solid #C29F6B' }}
          mt="8"
          disabled={!btnActive}
          isLoading={loading}
        >
          <Text
            textAlign="center"
            casing="uppercase"
            fontWeight="500"
            fontFamily="JosefinSans"
            fontSize={['12px', '12px', '14px', '14px', '14px']}
          >
            {t('minigame-reward-btn')}
          </Text>
        </Button>
      </Box>
    </>
  );
};
export default GameReward;
